import {useQuery} from 'react-query'
import {parseISO} from 'date-fns'
import {api} from 'base'

const REQUEST_APPROVED_STATUSES = [
  'approved',
  // 'received',
  'confirmed',
]
const REQUEST_DECLINED_STATUSES = [
  'declined',
]
const REQUEST_CURRENT_STATUSES = [
  'opened',
  'created',
  'document-check',
  'final-approval',
  'loans-coordinator-check',
  'lending-manager-check',
  'financial-controller-check',
  'director-check',
]

type RequestsKeyType = 'current' | 'approved' | 'declined'

export const useGetRequests = (status?: RequestsKeyType) => {
  return useQuery<any>(['drawdown-requests', status], async () => {
    const {data} = await api.get('/drawdown/list', {
      params: {
        include: ['project'],
        sort: 'createdAt',
        filter:
          (status === 'approved') ? {status: REQUEST_APPROVED_STATUSES}
          :
          (status === 'declined') ? {status: REQUEST_DECLINED_STATUSES}
          :
          (status === 'current') ? {status: REQUEST_CURRENT_STATUSES}
          :
          undefined,
        },
    })
    const sortedData: any[] = data.data.slice()
    sortedData.sort((a, b) => +parseISO(b.createdAt) - +parseISO(a.createdAt))
    return sortedData
  })
}
